import { StateCreator } from 'zustand';
import { Session, User, subscription } from '../../AuthDataTypes';
import { emitEvent } from '@/services/EventService';

export interface AuthZustandSlice {
    user: User | null;

    login: (userData: User) => void;
    logout: () => void;
    updateUser: (userData: User) => void;
    updateSubscriptions: (subscriptions: subscription[]) => void;
    updateFavouriteEdition: (edition: string) => void;

    _hasHydrated: boolean;
    setHasHydrated: (state: any) => void;
}

export const createAuthZustandSlice: StateCreator<AuthZustandSlice> = (set, get) => ({
    user: null,
    session: null,

    login: (userData: User) => {
        set({ user: userData });
        emitEvent('LoginEvent', null);
    },
    logout: () => {
        set({ user: null});
    },
    updateUser: (userData: User) => set({ user: userData }),
    updateFavouriteEdition: (favouriteEdition: string) => {
        const user = get().user;
        if (user) {
            set({
                user: {
                    ...user, 
                    favouriteEdition,
                },
            });
        }
    },
    updateSubscriptions: (subscriptions: subscription[]) => {
        const user = get().user;
        if (user) {
            set({
                user: {
                    ...user, 
                    subscriptions,
                },
            });
        }
    },

    _hasHydrated: false,
    setHasHydrated: (state: any) => {
        set({
            _hasHydrated: state
        });
    },
});